module.exports = __webpack_public_path__ + "img/sankaku_18_red.c9ac7315.png";